import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { getCurrentOrgUser, isOrgUserAuthenticated, logoutOrgUser } from '../api/orgAuthService';

const OrgAuthContext = createContext();

export function useOrgAuth() {
  return useContext(OrgAuthContext);
}

export function OrgAuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const isOrgRelatedPath = (pathname) => {
    return pathname.includes('/BespokeBridge/') || pathname.includes('/admin/');
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) setLoading(true);

      try {
        if (user) {
          const isOrg = await isOrgUserAuthenticated();
          if (isOrg) {
            const orgUser = await getCurrentOrgUser();
            setCurrentUser(orgUser);
          } else {
            const currentPath = window.location.pathname;
            if (isOrgRelatedPath(currentPath)) {
              setCurrentUser(null);
            }
          }
        } else {
          const currentPath = window.location.pathname;
          const isExplicitLogout = sessionStorage.getItem('org_explicit_logout') === 'true';
          if (isOrgRelatedPath(currentPath) || isExplicitLogout) {
            setCurrentUser(null);
            sessionStorage.removeItem('org_explicit_logout');
          }
        }
      } catch (error) {
        console.error('OrgAuthContext error:', error);
        const currentPath = window.location.pathname;
        if (isOrgRelatedPath(currentPath)) setCurrentUser(null);
      } finally {
        setLoading(false);
      }
    });

    return unsubscribe;
  }, []);

  const handleOrgLogout = async () => {
    try {
      sessionStorage.setItem('org_explicit_logout', 'true');
      setCurrentUser(null);
      await logoutOrgUser();
      return true;
    } catch (error) {
      sessionStorage.removeItem('org_explicit_logout');
      throw error;
    }
  };

  const value = { currentUser, loading, logout: handleOrgLogout };

  return (
    <OrgAuthContext.Provider value={value}>
      {children}
    </OrgAuthContext.Provider>
  );
}
